import { render, staticRenderFns } from "./PRF102P02.vue?vue&type=template&id=9b5901a2&"
import script from "./PRF102P02.vue?vue&type=script&lang=js&"
export * from "./PRF102P02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports